import React from "react";
import { ContentGrid, FileInput } from "../styles";
import { Card, Button, Field, Pill } from "../components";
import Icon from "../components/Icon";

const OtherView = ({
  approverRequested,
  setApproverRequested,
  approverNote,
  setApproverNote,
  approverDocs,
  setApproverDocs,
  preferredCurrency,
  setPreferredCurrency,
  pushToast,
  uid,
  setAudit,
}) => {
  return (
    <ContentGrid>
      <Card title="Other Settings • Approver Request" icon="shield" right={<Pill tone={approverRequested ? "c" : "d"}>{approverRequested ? "Pending review" : "Not requested"}</Pill>}>
        <ContentGrid>
          <div style={{ fontSize: 12, color: "rgba(210,235,245,.78)" }}>
            You can request to become an <b>Approver</b>. Attach required documents and add a note for the compliance team.
          </div>

          <ContentGrid>
            <div style={{ fontWeight: 900 }}>Supporting documents</div>
            <FileInput
              type="file"
              multiple
              onChange={(e) => setApproverDocs(Array.from(e.target.files || []))}
            />
            {approverDocs.length > 0 ? <Pill tone="d">{approverDocs.length} file(s) selected</Pill> : null}
          </ContentGrid>

          <Field
            label="Note to compliance"
            value={approverNote}
            onChange={setApproverNote}
            placeholder="Describe your role, experience, and why you request approver permissions"
          />

          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", flexWrap: "wrap" }}>
            <Button
              onClick={() => {
                setApproverRequested(true);
                pushToast("Approver", "Request submitted for review");
                setAudit((s) => [{ id: uid(), ts: "2026-01-08 09:30", actor: "user", type: "Approver", detail: "Approver request submitted", severity: "med" }, ...s]);
                console.log("approverRequest", {
                  note: approverNote,
                  documents: approverDocs.map((f) => ({ name: f.name, size: f.size })),
                  submittedAt: new Date().toISOString(),
                });
              }}
              disabled={approverRequested}
              icon="check"
            >
              Submit request
            </Button>
          </div>
        </ContentGrid>
      </Card>

      {/* Preferred Currency Selection */}
      <Card title="Preferred Currency" icon="dollar-sign">
        <ContentGrid>
          <div style={{ fontSize: 12, color: "rgba(210,235,245,.78)", marginBottom: 16 }}>
            Select your preferred currency for displaying prices and transactions.
          </div>

          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            <button
              onClick={() => {
                setPreferredCurrency("USD");
                pushToast("Currency", "Preferred currency set to USD");
                console.log("preferredCurrency", { currency: "USD", updatedAt: new Date().toISOString() });
              }}
              style={{
                height: "44px",
                padding: "0 24px",
                borderRadius: "12px",
                border: preferredCurrency === "USD" ? "1px solid rgba(92,233,255,.30)" : "1px solid rgba(92,233,255,.16)",
                background: preferredCurrency === "USD" ? "linear-gradient(90deg, rgba(92,233,255,.95), rgba(0,247,210,.92))" : "rgba(255,255,255,.06)",
                color: preferredCurrency === "USD" ? "#041018" : "rgba(240,250,255,.92)",
                fontWeight: 800,
                cursor: "pointer",
                transition: "all 0.2s ease",
                flex: "1 1 0",
                minWidth: "120px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: preferredCurrency === "USD" ? "0 14px 38px rgba(0,247,210,.14)" : "none",
              }}
              onMouseEnter={(e) => {
                if (preferredCurrency !== "USD") {
                  e.currentTarget.style.background = "rgba(255,255,255,.10)";
                  e.currentTarget.style.transform = "translateY(-1px)";
                }
              }}
              onMouseLeave={(e) => {
                if (preferredCurrency !== "USD") {
                  e.currentTarget.style.background = "rgba(255,255,255,.06)";
                  e.currentTarget.style.transform = "translateY(0)";
                }
              }}
            >
              USD
            </button>
            <button
              onClick={() => {
                setPreferredCurrency("EUR");
                pushToast("Currency", "Preferred currency set to EUR");
                console.log("preferredCurrency", { currency: "EUR", updatedAt: new Date().toISOString() });
              }}
              style={{
                height: "44px",
                padding: "0 24px",
                borderRadius: "12px",
                border: preferredCurrency === "EUR" ? "1px solid rgba(92,233,255,.30)" : "1px solid rgba(92,233,255,.16)",
                background: preferredCurrency === "EUR" ? "linear-gradient(90deg, rgba(92,233,255,.95), rgba(0,247,210,.92))" : "rgba(255,255,255,.06)",
                color: preferredCurrency === "EUR" ? "#041018" : "rgba(240,250,255,.92)",
                fontWeight: 800,
                cursor: "pointer",
                transition: "all 0.2s ease",
                flex: "1 1 0",
                minWidth: "120px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: preferredCurrency === "EUR" ? "0 14px 38px rgba(0,247,210,.14)" : "none",
              }}
              onMouseEnter={(e) => {
                if (preferredCurrency !== "EUR") {
                  e.currentTarget.style.background = "rgba(255,255,255,.10)";
                  e.currentTarget.style.transform = "translateY(-1px)";
                }
              }}
              onMouseLeave={(e) => {
                if (preferredCurrency !== "EUR") {
                  e.currentTarget.style.background = "rgba(255,255,255,.06)";
                  e.currentTarget.style.transform = "translateY(0)";
                }
              }}
            >
              EUR
            </button>
          </div>

          {preferredCurrency && (
            <div style={{ marginTop: 12, fontSize: 12, color: "rgba(210,235,245,.6)" }}>
              Current selection: <strong style={{ color: "#00f7d2" }}>{preferredCurrency}</strong>
            </div>
          )}
        </ContentGrid>
      </Card>
    </ContentGrid>
  );
};

export default OtherView;
